import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import API from '../config/apiConfig'

Vue.use(Vuex)
const store = new Vuex.Store({
  state: {
    routes: '', // 监听路由的变化
    loading: false,
    closeTab: '', // 是否关闭当前路由
    userinfo: '',
    productType: [], // 产品类型
    sysData: [], // 业务系统
    stragyData: [] // 计价策略
  },
  mutations: {
    loading (state, op) {
      state.loading = op
    },
    setinfo (state, op) {
      state.userinfo = op
    },
    closeTab (state, op) {
      state.closeTab = op
    }
  },
  actions: {
    getProductType ({ state }) { // 请求产品类型
      axios({
        method: 'post',
        url: API.product.getProdTypeList,
        data: { 'pageNum': 1, 'pageSize': 50 }
      }).then((response) => {
        state.productType = response.data.resData.resultList
      }).catch((error) => {
        console.log(error)
      })
    },
    getSystem ({ state }) { // 请求业务系统
      console.log(API.apiList)
      axios({
        method: 'post',
        url: API.apiList.querySysList,
        data: { 'pageNum': 1, 'pageSize': 50 }
      }).then((response) => {
        if (!response.data.resData) return
        state.sysData = response.data.resData
      }).catch((error) => {
        console.log(error)
      })
    },
    changeRoute ({state, rootState, dispatch}, op) {
      state.routes = op
      if (op.path === '/editAbilityManage' && op.query.id && op.query && op.query.isfresh === true) {
        rootState.editPromain.table = [] // 防止共用组件共用一个值
        rootState.editPromain.index = ''
        rootState.editPromain.ifDrop = false
        rootState.editPromain.prodId = op.query.id
        dispatch('editPromain/getPathTable', { 'prodId': op.query.id, 'pageNum': 1, 'pageSize': 10 })
      }
    }
  },
  modules: {
    super: {
      namespaced: true,
      state: {
        table: null,
        total: null
      },
      mutations: {
        settable (state, val) {
          state.table = val
        },
        total (state, val) {
          state.total = val
        }
      },
      actions: {
        getTable ({ state }, op) {
          axios({
            method: 'post',
            url: API.supplier.getSupServiceListByPage,
            data: op,
            dataType: 'json',
            contentType: 'application/json; charset=utf-8',
            headers: {'mtk': localStorage.getItem('usermtk')},
            crossDomain: true
          }).then((response) => {
            state.table = response.data.resData.rows
            state.total = response.data.resData.total
          }).catch((error) => {
            console.log(error)
          })
        }
      }
    },
    editPromain: {
      namespaced: true,
      state: {
        table: [], // 通道组
        index: '',
        total: 0, // 总数
        ifDrop: false, // 是否排序
        prodId: '' // 产品id
      },
      getters: {
        contacts: state => state.table
      },
      mutations: {
        changeIndex (state, val) {
          state.index = val
        },
        addPath (state, op) { // 通道组添加关联通道
          state.table[state.index].table.push(op) // 往通道组添加关联通道
          state.table = state.table.slice(0) // 克隆数组
          console.log(state.table[state.index].table)
        },
        clear (state, op) {},
        sort (state, op) {
          const oldItem = state.table[op.index].table[op.oldIndex]
          let arr = state.table[op.index].table.slice(0) // 克隆数组
          arr.splice(op.oldIndex, 1)
          arr.splice(op.newIndex, 0, oldItem)
          arr.forEach((v, i) => {
            v.groupIndex = i + 1 // 增加排序的优先级
            v = Object.assign({}, v)
          })
          state.table[op.index].table = arr // 整体重新赋值
          state.table = state.table.slice(0) // 克隆数组
        },
        changeProdId (state, val) { // 改变产品id
          state.prodId = val
        },
        ifDrop (state, val) {
          state.ifDrop = val
        }
      },
      actions: {
        getPathTable ({ state }, op) { // 请求关联通道组
          axios({
            method: 'post',
            url: API.product.queryGroupList,
            data: op
          }).then((response) => {
            if (!response.data.resData) return
            state.table = response.data.resData.resultList
            state.total = response.data.resData.total
            state.table.forEach((item, i) => {
              item.table = []
              item.index = i
            })
            let oldArr = state.table
            let newArr = oldArr.slice(0) // 克隆数组
            state.table = newArr // 整体重新赋值
          }).catch((error) => {
            console.log(error)
          })
        },
        httpChannel ({ state }, row) { // 请求通道组关联通道
          let op = {}
          op.prodId = state.prodId
          op.groupId = row.groupId
          axios({
            method: 'post',
            url: API.product.queryPipeListByGroup,
            data: op
          }).then((response) => {
            if (response.data.resData && response.data.resData.prodPipeRefList) {
              let arr = response.data.resData.prodPipeRefList
              state.table[row.index].table.splice(0, state.table[row.index].table.length) // 每次重新请求清空
              arr.forEach((item, i) => {
                item.groupIndex = i + 1 // 生成优先级
                state.table[row.index].table.push(item) // 使用push方法更新视图
              })
              state.ifDrop = true
            }
          }).catch((error) => {
            console.log(error)
          })
        }
      }
    },
    addPromain: { // 防止共用组件出现数据共享，编辑和新增加以区分
      namespaced: true,
      state: {
        table: [], // 通道组
        index: '',
        total: 0, // 总数
        ifDrop: false, // 是否排序
        prodId: '' // 产品id
      },
      getters: {
        contacts: state => state.table
      },
      mutations: {
        changeIndex (state, val) {
          state.index = val
        },
        addPath (state, op) { // 通道组添加关联通道
          state.table[state.index].table.push(op) // 往通道组添加关联通道
          state.table = state.table.slice(0) // 克隆数组
          console.log(state.table[state.index].table)
        },
        clear (state, op) {},
        sort (state, op) {
          const oldItem = state.table[op.index].table[op.oldIndex]
          let arr = state.table[op.index].table.slice(0) // 克隆数组
          arr.splice(op.oldIndex, 1)
          arr.splice(op.newIndex, 0, oldItem)
          arr.forEach((v, i) => {
            v.groupIndex = i + 1 // 增加排序的优先级
            v = Object.assign({}, v)
          })
          state.table[op.index].table = arr // 整体重新赋值
          state.table = state.table.slice(0) // 克隆数组
        },
        changeProdId (state, val) { // 改变产品id
          state.prodId = val
        },
        ifDrop (state, val) {
          state.ifDrop = val
        }
      },
      actions: {
        getPathTable ({ state }, op) { // 请求关联通道组
          axios({
            method: 'post',
            url: API.product.queryGroupList,
            data: op
          }).then((response) => {
            if (!response.data.resData) return
            state.table = response.data.resData.resultList
            state.total = response.data.resData.total
            state.table.forEach((item, i) => {
              item.table = []
              item.index = i
            })
            let oldArr = state.table
            let newArr = oldArr.slice(0) // 克隆数组
            state.table = newArr // 整体重新赋值
          }).catch((error) => {
            console.log(error)
          })
        },
        httpChannel ({ state }, row) { // 请求通道组关联通道
          let op = {}
          op.prodId = state.prodId
          op.groupId = row.groupId
          axios({
            method: 'post',
            url: API.product.queryPipeListByGroup,
            data: op
          }).then((response) => {
            if (response.data.resData && response.data.resData.prodPipeRefList) {
              let arr = response.data.resData.prodPipeRefList
              state.table[row.index].table.splice(0, state.table[row.index].table.length) // 每次重新请求清空
              arr.forEach((item, i) => {
                item.groupIndex = i + 1 // 生成优先级
                state.table[row.index].table.push(item) // 使用push方法更新视图
              })
              state.ifDrop = true
            }
          }).catch((error) => {
            console.log(error)
          })
        }
      }
    }
  }
})
export default store



// WEBPACK FOOTER //
// ./src/store/index.js